import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetBillableAmountQuery } from "../../../services/Reports";
import {
  getBillableAmountRequest,
  getBillableAmountFailure,
  getBillableAmountSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allBillableAmount,
    isLoading: billableAmountLoading,
    isError: billableAmountError,
  } = useGetBillableAmountQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.billableAmountPageNo,
    pageSize: state.billableAmountPageSize,
    fromDate: new Date(state.billableAmountFromDate).toLocaleDateString(),
    toDate: new Date(state.billableAmountToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (billableAmountLoading) {
      dispatch(getBillableAmountRequest());
    }
    if (billableAmountError) {
      dispatch(getBillableAmountFailure(billableAmountError));
    }
    if (allBillableAmount) {
      dispatch(
        getBillableAmountSuccess({
          data: allBillableAmount.data.purchaseByVendor[0].data || [],
          totalPages:
            allBillableAmount.data.purchaseByVendor[0].metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allBillableAmount,
    profileData,
    state.billableAmountFromDate,
    state.billableAmountToDate,
    state.billableAmountPageNo,
    state.billableAmountPageSize,
  ]);
  return <></>;
};
export default Content;
